module.exports = __webpack_public_path__ + "img/marco-pro.06f4ef9f.jpg";